
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PsPromoApDtDialog extends Serenity.Extensions.GridEditorDialog<PsPromoApDtRow> {
        protected getFormKey() { return PsPromoApDtForm.formKey; }
        // protected getIdProperty() { return PsPromoApDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoApDtRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoApDtRow.nameProperty; }
        // protected getService() { return PsPromoApDtService.baseUrl; }
        // protected getDeletePermission() { return PsPromoApDtRow.deletePermission; }
        // protected getInsertPermission() { return PsPromoApDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsPromoApDtRow.updatePermission; }

        protected form = new PsPromoApDtForm(this.idPrefix);

        // public myId: number;
        // public sku: string;
        // public gpcon: string;

        constructor() {
            super();

            this.form = new PsPromoApDtForm(this.idPrefix);

           

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );            

            return buttons;
        }

        

    }
}